import React, { memo, useCallback } from 'react'
import fetchAPI from '../../../../../../lib/utils/fetch-api'
import { ExportExcelButton, format2Print } from 'src/react-app/components/v2/export-excel-button'
import dayjs from 'dayjs'
import { formatPhoneNumber } from '../../../../../../lib/utils/helpers'
import {
  formatWithDisplayPattern,
  parseDisplayFormatValue,
} from '../../../../../components/input-text/mask-utils'

const SNILS_FORMAT = '000-000-000 00'

export interface EmployeePrintButtonProps {
  path: string
  columns: any[]
}

export const EmployeePrintButton: React.FC<EmployeePrintButtonProps> = memo(props => {
  const { path, columns } = props

  const handlePrintClick = useCallback(async () => {
    try {
      const response = await fetchAPI(path)
      const data = response.data
      if (!data) {
        return
      }

      const viewColumnNames = columns.map(column => column.dataIndex)
      const count = data.length

      for (let i = 0; i < count; i++) {
        let keys = Object.keys(data[i])
        keys.forEach(key => {
          if (!viewColumnNames.includes(key)) {
            return
          }

          if (key === 'employment_date' || key === 'dismissal_date') {
            data[i][key] = data[i][key] ? dayjs(data[i][key]).format('DD.MM.YYYY') : data[i][key]
            return
          }

          if (key === 'created_at' || key === 'updated_at') {
            data[i][key] = data[i][key]
              ? dayjs(data[i][key]).format('DD.MM.YYYY HH:mm')
              : data[i][key]
            return
          }

          if (key === 'phone') {
            data[i][key] = formatPhoneNumber(data[i][key])
            return
          }

          if (key === 'snils') {
            if (data[i][key] == null || data[i][key] === '') {
              return
            }
            const digits = parseDisplayFormatValue(String(data[i][key]), SNILS_FORMAT)
            data[i][key] = formatWithDisplayPattern(digits, SNILS_FORMAT)
            return
          }

          if (key === 'is_active') {
            data[i][key] = data[i][key] ? 'Активен' : 'Уволен'
            return
          }

          if (key === 'dismissal_reason') {
            if (!data[i][key] || data[i][key] === '') {
              data[i][key] = ''
            }
            return
          }

          data[i][key] = format2Print(key, data[i][key])
        })
      }

      return data
    } catch (e) {
      console.log('handlePrintClick', e)
    }
  }, [columns, path])

  return (
    <ExportExcelButton
      fileName={'Сотрудники'}
      path={path}
      columns={columns}
      onPrintClick={handlePrintClick}
    />
  )
})
